import axios from "axios";
import store from "@/store";

const BASE = import.meta.env.VITE_API_URL;

/**
 * Enum for HTTP method types.
 * @readonly
 * @enum {string}
 */
const MethodType = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE"
};

/**
 * Makes an axios HTTP request with the specified method, URL, and payload.
 *
 * @param {string} method - The HTTP method to use for the request (e.g., 'GET', 'POST').
 * @param {string} url - The URL to which the request is sent.
 * @param {Object} payload - The data to be sent as the request body.
 * @returns {Promise<Object>} - A promise that resolves to the response object or the error response object.
 */
async function axiosCall(method, url, data) {
  return axios({
    method,
    url,
    data,
    headers: {
      Authorization: `Bearer ${store.getters.getToken}`
    }
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

export { axiosCall, MethodType, BASE };
